import { SettingsSidebarLink as SettingsSidebarLinkType } from '@/types/shared/settings-sidebar/settings-sidebar-link';
import { cn } from '@/utils/shared/Utils';
import { NavLink, useLocation } from 'react-router-dom';

interface SidebarLinkProps {
  link: SettingsSidebarLinkType;
}

export function SettingsSidebarLink({ link }: SidebarLinkProps) {
  const { pathname } = useLocation();
  const isActive = pathname.includes(link.to);

  return (
    <li className="mr-0.5 md:mr-0 md:mb-0.5">
      <NavLink
        end
        to={link.to}
        className={`flex items-center px-2.5 py-2 rounded-lg whitespace-nowrap ${
          isActive &&
          'bg-[linear-gradient(135deg,var(--tw-gradient-stops))] from-violet-500/[0.12] dark:from-violet-500/[0.24] to-violet-500/[0.04]'
        }`}
      >
        <link.Icon
          className={cn(
            'shrink-0 fill-current -ml-1 mr-2',
            isActive ? 'text-violet-500 dark:text-violet-400' : 'text-gray-400 dark:text-gray-500',
          )}
          focusable="false"
          aria-hidden="true"
          viewBox="0 0 24 24"
          width="20"
          height="20"
        />
        <span
          className={cn(
            'text-sm font-medium',
            isActive
              ? 'text-violet-500 dark:text-violet-400'
              : 'text-gray-600 dark:text-gray-300 hover:text-gray-700 dark:hover:text-gray-200',
          )}
        >
          {link.label}
        </span>
      </NavLink>
    </li>
  );
}
